export default __webpack_public_path__ + "static/media/0086.ec155ac4.jpg";